import { HttpAPIError, HttpReqError } from "@/api/model"
import { getAppConfig } from "@/config/env"
import axios, { AxiosError } from "axios"
import { store } from "@/store"

const instance = axios.create({
  baseURL: getAppConfig().baseAPIUrl,
  timeout: 150000,
  withCredentials: true,
})

const withoutAuthUrls = ["/v1/getID", "/tenant/login"]

instance.interceptors.request.use((config) => {
  const { headers } = config
  const needAuth = !withoutAuthUrls.some((url) => config.url?.includes(url))
  // 添加请求头授权，直接从 redux store 读取最新 auth
  const auth = store.getState().auth.auth
  if (auth !== null && needAuth) {
    headers["x-company-uniq-id"] = auth.companyUniqID
    headers["x-token"] = auth.token
  }

  return config
})

// 请求返回的统一格式
interface APIRawRes {
  msg: string
  message: string
  code: number
  data: any
}

instance.interceptors.response.use(
  (response) => {
    const {
      data,
      config: { url },
    } = response
    // 该接口没有统一返回格式，这里做特殊解析处理，返回 id 字段
    if (url === `/v1/getID`) {
      response.data = data.id
      return response
    }
    // /client-config：需保留完整响应（HTTP 状态、ETag、业务码），由调用方自行解析；
    // 304 响应体为空，不能走统一拆包逻辑。validateStatus 已放行 <400。
    if (url === "/client-config") {
      return response
    }
    // /instance/wanip 原始响应兼容逻辑暂不启用

    let res: APIRawRes
    if (url === "/tenant/vps/states" || url === "/tenant/vps/control") {
      // 该接口的返回结果是一个json字符串，需要先解析成对象 （历史遗留原因） ,返回的message是错误信息，不是msg，所以要兼容message
      res = JSON.parse(data as string)
    } else {
      res = data as APIRawRes
    }

    if (res.code !== 0) {
      // 业务错误：同时传递后端返回的 data，便于上层按业务流程处理
      return Promise.reject(
        new HttpAPIError(res.code, res.msg || res.message, res.data)
      )
    }

    // 请求成功
    response.data = res.data
    return response
  },
  (error: AxiosError) => {
    const path = error.config?.url
    const status = error.response?.status
    return Promise.reject(new HttpReqError(path, status))
  }
)

export const http = instance
export default http

/* [日志上传功能已注释]
// 独立 axios 实例：用于上传日志到预签名 URL（KS3/S3）。
// 不走业务拦截器、不注入 x-token、不解析统一返回格式；PUT 裸字节。
// 对齐 android API.uploadLogZip 的独立 Dio 实例。
const uploadInstance = axios.create({
  timeout: 30000,
  withCredentials: false,
})

export const httpNoAuth = uploadInstance
*/
